export default {
  url: 'integrator-4795701.okta.com',
  issuer: 'https://integrator-4795701.okta.com/oauth2/default',
  redirect_uri: window.location.origin + '/implicit/callback',
  client_id: process.env.REACT_APP_AUTHPROVIDERCID || '0oaws3zjpdcwBlp63697',
  recaptcha_site_key: process.env.REACT_APP_REAPTCHASITEKEY || '6Ld6_NAqAAAAAG-NzyfebI_eoWB74AlSJz1Z_-xl',
  // AWS Lex Config (Aligning with libhacontimig Android implementation)
  lexBotId: process.env.REACT_APP_LEX_BOT_ID || 'HealthDashSupportBot',
  lexBotAliasId: process.env.REACT_APP_LEX_BOT_ALIAS_ID || 'PROD',
  lexLocaleId: 'en_US'
}